
import useHasCompanionMode from './useHasCompanionMode.js';

export default function useGetSources() {
    const inCompanionMode = useHasCompanionMode();
    return inCompanionMode ? RivalIQ.metrics.new.enums.ListeningSources.QuidSources : RivalIQ.metrics.new.enums.ListeningSources.RivalIQSources;
}
